import axios from "axios";
import { api } from "..";
import { AnalysisOption, Pipeline  } from "../../types/domain";

export const getPipelineAnalysisOptions = async (): Promise<AnalysisOption[]> =>  {
  const response = await axios.get('/api/analysis/4');
  return response.data?.data ?? [];
};

export const createPipeline = async (pipeline: Pipeline): Promise<string> => {
  const response = await api.post('/pipeline', pipeline);
  if(response.status === axios.HttpStatusCode.Created) {
    const responseDto = response.data;
    return responseDto.data;
  }
  throw new Error(`Failed to create pipeline. Status: ${response.status}`);
}

export const getPipelines = async (): Promise<Pipeline[]> => {
  const response = await axios.get(`/api/pipeline`);
  const responseDto = response.data;
  return responseDto.data.map((pipeline: any) => {
    const analysisDisplayOptions = pipeline.analysisFields?.map((field: any) => ({
      index: field.index,
      isMandatory: field.isMandatory,
      isReadonly: field.isReadonly,
      shortName: field.shortName,
      fullName: field.fullName
    })) ?? [];
    
    return {
      id: pipeline.id,
      name: pipeline.name,
      description: pipeline.description,
      analysisDisplayOptions: analysisDisplayOptions,
      stages: pipeline.stages,
      quotationEnabled: pipeline.quotationEnabled,
      inUse: pipeline.inUse
    };
  });
};

export const getPipeline = async (id: string | undefined): Promise<Pipeline> => {
  const response = await axios.get(`/api/pipeline/${id}`);
  const responseDto = response.data;
  
  const analysisDisplayOptions = responseDto.data.analysisFields?.map((field: any) => ({
    index: field.index,
    isMandatory: field.isMandatory,
    isReadonly: field.isReadonly,
    shortName: field.shortName,
    fullName: field.fullName
  })) ?? [];
  
  return {
    id: responseDto.data.id,
    name: responseDto.data.name,
    description: responseDto.data.description,
    analysisDisplayOptions: analysisDisplayOptions,
    stages: responseDto.data.stages,
    quotationEnabled: responseDto.data.quotationEnabled,
  };
};

export const updatePipeline = async (pipeline: Pipeline): Promise<string> => {
  const response = await api.put(`/pipeline/${pipeline.id}`, pipeline);
  if(response.status === axios.HttpStatusCode.Ok) {
    return "";
  }
  throw new Error(`Failed to update pipeline. Status: ${response.status}`);
};

export const deletePipeline = async (id: string | undefined): Promise<string> => {
  const response = await api.delete(`/pipeline/${id}`);
  if(response.status === axios.HttpStatusCode.NoContent) {
    return "";
  }
  throw new Error(`Failed to delete pipeline. Status: ${response.status}`);
};
